import { DropdownOptionModel } from './dropdown-option-model';

import {
  PersonalLoanRegistrationRequest
} from '../shared/models/index';

import ProjectType = PersonalLoanRegistrationRequest.ProjectTypeEnum;

export const PROJECT_TYPE_OPTIONS: DropdownOptionModel<ProjectType>[] = [
  { value: ProjectType.ConcreteBrickAndStone, display: 'Concrete, Brick and Stone' },
  { value: ProjectType.DeckingShadeStructures, display: 'Decking/Shade Structures' },
  { value: ProjectType.Electrical, display: 'Electrical' },
  { value: ProjectType.FlooringAndHardwood, display: 'Flooring and Hardwood' },
  { value: ProjectType.GeneralContractor, display: 'General Contractor' },
  { value: ProjectType.Generators, display: 'Generators' },
  { value: ProjectType.HeatingAndAC, display: 'Heating and A/C' },
  { value: ProjectType.HurricaneStructures, display: 'Hurricane Structures' },
  { value: ProjectType.Insulation, display: 'Insulation' },
  { value: ProjectType.Landscaping, display: 'Landscaping' },
  { value: ProjectType.Lighting, display: 'Lighting' },
  { value: ProjectType.PaintingAndStaining, display: 'Painting and Staining' },
  { value: ProjectType.PlumbingAndHeating, display: 'Plumbing and Heating' },
  { value: ProjectType.Remodeling, display: 'Remodeling' },
  { value: ProjectType.Roofing, display: 'Roofing' },
  { value: ProjectType.Seawalls, display: 'Seawalls' },
  { value: ProjectType.Seismic, display: 'Seismic' },
  { value: ProjectType.Solar, display: 'Solar' },
  { value: ProjectType.SwimmingPoolsAndSpas, display: 'Swimming Pools and Spas' },
  { value: ProjectType.WaterSaving, display: 'Water Saving' },
  { value: ProjectType.WindowsAndDoors, display: 'Windows and Doors' }
];
